import React from 'react';
import { Form, Input, Button } from 'antd';
import { Website } from '../../types';

interface WebsiteFormProps {
  data?: Website;
  onSubmit: (data: Website) => void;
}

const WebsiteForm: React.FC<WebsiteFormProps> = ({ data, onSubmit }) => {
  const handleSubmit = (values: any) => {
    onSubmit(values);
  };

  return (
    <Form
      layout="vertical"
      initialValues={{
        title: data ? data.title : '',
        url: data ? data.url : '',
      }}
      onFinish={handleSubmit}
    >
      <Form.Item
        label="Title:"
        name="title"
        rules={[{ required: true, message: 'Please input website name' }]}
      >
        <Input size="large" />
      </Form.Item>

      <Form.Item
        label="URL:"
        name="url"
        rules={[
          { required: true, type: 'url', message: 'Please input website url' },
        ]}
      >
        <Input size="large" />
      </Form.Item>

      <Button type="primary" htmlType="submit" size="large">
        {data ? 'Save' : 'Create'}
      </Button>
    </Form>
  );
};

export default WebsiteForm;
